var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGuarantorWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 57,
    viewBox: "0 0 77 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 77,
    height: 57
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.668457,
    y: 0.904785,
    width: 75.5801,
    height: 56.0952,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.38 32.216L60.1038 27.1641C59.6313 26.9845 58.6517 26.7488 57.5454 27.1641L44.2691 32.216C43.036 32.6875 42.2293 33.7877 42.2293 35.0114C42.2293 47.54 50.1466 56.2068 57.5454 59.0246C58.6517 59.44 59.6198 59.2043 60.1038 59.0246C66.0159 56.7794 75.4199 48.9882 75.4199 35.0114C75.4199 33.7877 74.6132 32.6875 73.38 32.216ZM58.8246 53.6921V32.463L69.8305 36.6504C69.1851 46.4286 62.8121 51.851 58.8246 53.6921V53.6921ZM27.4779 30.5208C35.6257 30.5208 42.2293 24.0881 42.2293 16.151C42.2293 8.21397 35.6257 1.78125 27.4779 1.78125C19.3301 1.78125 12.7265 8.21397 12.7265 16.151C12.7265 24.0881 19.3301 30.5208 27.4779 30.5208ZM38.5414 35.0114C38.5414 34.7307 38.6336 34.4725 38.6682 34.2031C38.3801 34.1919 38.1035 34.1133 37.8039 34.1133H35.8793C33.3208 35.2584 30.4743 35.9095 27.4779 35.9095C24.4815 35.9095 21.6465 35.2584 19.0765 34.1133H17.1519C8.60072 34.1133 1.66296 40.8716 1.66296 49.2015V53.8717C1.66296 56.8467 4.14074 59.2604 7.19473 59.2604H47.761C48.5447 59.2604 49.2938 59.092 49.9737 58.8113C43.7505 53.9952 38.5414 45.7101 38.5414 35.0114Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuarantorWhite);
export default __webpack_public_path__ + "static/media/guarantor-white.ea78ca24.svg";
export { ForwardRef as ReactComponent };